<template>
  <div>
    <el-form label-width="120px" label-position="right">
      <el-collapse v-model="activeNames" class="myDivider">
        <el-collapse-item title="申请信息" name="1">
          <el-form-item label="申请说明：">
            <div class="remark">{{detail.applicationDesc}}</div>
          </el-form-item>
          <el-form-item label="检查报告：">
            <!-- <el-image style="width: 100px; height: 100px" :src="url"  :preview-src-list="srcList" /> -->
            <template v-for="(imgItem, index) in detail.applicationPicture">
              <el-image style="width: 100px; height: 100px" :src="detail.applicationPicture[index]" :preview-src-list="detail.applicationPicture" />
            </template>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="健康评估与管理方案" name="2">
          <!-- <div class="label_title"></div> -->
          <el-card class="box_card">
            <div slot="header" class="card_header">
              <span class="title">⭐ 运动健康管理</span>
            </div>
            <el-form-item label="评估总结：">
              <div class="remark">{{detail.sportSummary}}</div>
            </el-form-item>
            <el-form-item label="运动方案：">
              <div class="remark">{{detail.sportScheme}}</div>
            </el-form-item>
            <el-form-item label="睡眠方案：">
              <div class="remark">{{detail.sportSleepScheme}}</div>
            </el-form-item>
            <el-form-item label="健康管理师：">{{detail.healthManagePersonName}}</el-form-item>
          </el-card>
          <el-card class="box_card">
            <div slot="header" class="card_header">
              <span class="title">⭐ 疾病风险管理</span>
            </div>
            <el-form-item label="评估小结：">
              <div class="remark">{{detail.diseaseSummary}}</div>
            </el-form-item>
            <el-form-item label="医生建议：">
              <div class="remark">{{detail.diseaseDoctorAdvise}}</div>
            </el-form-item>
            <el-form-item label="医生：">{{detail.doctorName}}</el-form-item>
          </el-card>
          <el-card class="box_card">
            <div slot="header" class="card_header">
              <span class="title">⭐ 营养方案</span>
            </div>
            <el-form-item label="营养建议：">
              <div class="remark">{{detail.nutritionAdvise}}</div>
            </el-form-item>
            <el-form-item label="饮食方案：">
              <div class="remark">{{detail.nutritionScheme}}</div>
            </el-form-item>
            <el-form-item label="营养师：">{{detail.nutritionist}}</el-form-item>
          </el-card>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="myDivider2">
      <el-button type="primary" @click="closeDetail(false)">返回列表</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    serveiceDetail: {
      type: Object,
      default: {}
    }
  },
  watch: {
  },
  created() {
    this.getServeiceDetail();
  },
  data() {
    return {
      detail: {},
      activeNames: ['1'],
      // url: 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      // srcList: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg','https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg']
    }
  },
  methods: {
    closeDetail(b) {
      this.$emit('closeServiceDetail', b);
    },
    getServeiceDetail() {
      this.$https.get('system/memberServiceApplication/getApplicationById', { id: this.serveiceDetail.id }).then(res => {
        // this.memberForm
        // Object.assign(this.memberForm, this.memberForm.memberInfo);
        this.detail = res.data;
        if (this.detail.applicationPicture) {
          this.detail.applicationPicture = JSON.parse(this.detail.applicationPicture);
        } else {
          this.detail.applicationPicture = [];
        }
        console.log('服务详情========>', res.data);
      }).catch(res => {

      })
    }
  }
}
</script>

<style lang="less" scoped>
.myDivider {
    // padding: 10px;
    // margin: 20px 0;
    // background: rgb(192, 196, 204);
    // border-left: 4px solid #409EFF;
    // font-size: 15px;
    // font-weight: bold;
    /deep/ .el-collapse-item__header {
        margin-bottom: 15px;
        padding: 0 10px;
        background: #f1f1f1;
        border-left: 4px solid #f56c6c;
        font-size: 15px;
        font-weight: bold;
    }
}
.remark {
    padding: 10px;
    background: #eee;
    width: 400px;
}
.box_card {
    margin-bottom: 10px;
}
.card_header {
    padding: 5px;
    font-weight: bold;
    font-size: 13px;
    background: #dcd8d8;
}
.label_title {
    font-size: 12px;
    color: blue;
    background: #f3f3f3;
    padding: 5px;
}
.myDivider2 {
    // position: sticky;
    // top: 0;
    // z-index: 1;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    padding: 10px;
    margin: 20px 0;
    // background: #f1f1f1;
    // border-left: 4px solid #f56c6c;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
}
</style>
